var render, staticRenderFns
import script from "./CrtTemplate.vue?vue&type=script&lang=js&"
export * from "./CrtTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80e5ce74')) {
      api.createRecord('80e5ce74', component.options)
    } else {
      api.reload('80e5ce74', component.options)
    }
    
  }
}
component.options.__file = "src/views/Configuration/Templates/CrtTemplate.vue"
export default component.exports